"use client";

import { useEffect } from "react";

export default function ChunkErrorReload() {
  useEffect(() => {
    const handler = (event) => {
      if (
        event?.message?.includes("ChunkLoadError") ||
        event?.message?.includes("Loading chunk")
      ) {
        console.error("Chunk load error detected, reloading...");
        window.location.reload();
      }
    };

    window.addEventListener("error", handler);
    return () => window.removeEventListener("error", handler);
  }, []);

  return null;
}
